import i18n from "../i18n";

export const formatCurrency = (amount) => {
  if (typeof amount === "undefined") {
    return "-";
  }

  try {
    const currency = localStorage.getItem("currency")?.toUpperCase() || "SGD";

    if (currency === "USD") {
      return `USD ${amount}`;
    }

    if (currency === "TWD") {
      return `NT$${amount}`;
    }

    if (currency === "IDR") {
      // Format IDR in millions (e.g., Rp 8.3M) or thousands (e.g., Rp 8.3K)
      if (amount >= 1000000) {
        const inMillions = (amount / 1000000).toFixed(1);
        // Remove trailing zero if it's a whole number
        const formattedAmount = inMillions.endsWith('.0') 
          ? inMillions.slice(0, -2) 
          : inMillions;
        return `Rp ${formattedAmount}M`;
      } else if (amount >= 1000) {
        const inThousands = (amount / 1000).toFixed(1);
        // Remove trailing zero if it's a whole number
        const formattedAmount = inThousands.endsWith('.0') 
          ? inThousands.slice(0, -2) 
          : inThousands;
        return `Rp ${formattedAmount}K`;
      }
      return `Rp ${amount}`;
    }

    const formatter = new Intl.NumberFormat(i18n.language, {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    return formatter.format(amount);
  } catch (error) {
    console.error("Error formatting currency:", error);
    return `${amount}`; // Fallback to just the amount if formatting fails
  }
};
